import { SurveyDTO, SurveySubmissionDTO } from "@onetutor/shared/dto";
import { onetutorApi } from "./onetutorApi";

const surveyApi = onetutorApi.injectEndpoints({
  endpoints: (builder) => ({
    getSurvey: builder.query<SurveyDTO | null, string>({
      query: (courseId) => `course/${courseId}/survey`,
      providesTags: (_result, _error, courseId) => [
        { type: "survey", id: courseId },
      ],
    }),
    postSurvey: builder.mutation<
      void,
      { courseId: string; submission: SurveySubmissionDTO }
    >({
      query: ({ courseId, submission }) => ({
        url: `course/${courseId}/survey/submit`,
        method: "POST",
        body: { submission },
      }),
      invalidatesTags: ["survey"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSurveyQuery,
  useLazyGetSurveyQuery,
  usePostSurveyMutation,
} = surveyApi;
